import { useInlineFilterButtonsActions } from './useInlineFilterButtonsActions';
import { useInlineFilterButtonsDockedStates } from './useInlineFilterButtonsState';

export const useInlineFilterButtonsReducer = () => ({
  ...useInlineFilterButtonsActions(),
  ...useInlineFilterButtonsDockedStates(),
});
